import { useSelector } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';
import { useEffect, useState } from "react";
import Error from "./Error";

const checkToken = (token) => {
    try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        return decodedToken.exp > currentTime;
    } catch (error) {
        return false
    }
}

const ProtectedRoute = ({ children, requiredLevel }) => {
    const [isPermitAlert, setIsPermitAlert] = useState(true);
    const { level } = useSelector(state => state.user);
    const token = localStorage.getItem('ticino-wild-token');
    // Ritardo per non visualizzare il messaggio dei permessi
    const [isDelayDone, setIsDelayDone] = useState(false);
    useEffect(() => {
        setTimeout(() => {
            setIsDelayDone(true)
        }, 500)
    }, [])
    if (token && checkToken(token) && level >= requiredLevel) {
        return (
            <>
                <Outlet />
                {children}
            </>
        )
    } else if (token && checkToken(token) && level < requiredLevel) {
        setTimeout(() => {
            setIsPermitAlert(false)
        }, 3000)
        return (
            <div className="w-full flex justify-center">
                {!isPermitAlert && <Navigate to="/my-profile" />}
                {isPermitAlert && isDelayDone && <Error text="Permessi insufficienti per accedere alla pagina" />}
            </div>
        )

    }
    return <Navigate to="/register-login?section=Login" />
}

export default ProtectedRoute;